import configRoutes from "@/router/configRoutes";
import auth from "@/router/middlewares/auth";
import vegolaRoutes from "@/router/vegolaRoutes";

const routes = [

    {
        path: "/login",
        name: "login",
        component: () => import("../views/account/login.vue"),
        meta: {
            title: "Login",
            authRequired: false,
        },
    },
    {
        path: "/forgot-password",
        name: "Mot de pass oublié",
        component: () => import("../views/account/forgot-password.vue"),
        meta: {
            title: "Mot de passe oublié",
            authRequired: false,
        },
    },
    {
        path: "/password/reset/:token",
        name: "password-reset",
        component: () => import("../views/account/PasswordReset.vue"),
        meta: {
            title: "Réinitialisation du mot de passe",
            authRequired: false,
        },
    },
    {
        path: "/portail/investissements",
        name: "public-investments-map",
        component: () => import("../views/public/InvestmentsMapPublic.vue"),
        meta: {
            title: "Carte publique des investissements",
            authRequired: false,
        },
    },
    {
        path: "/",
        name: "default",
        meta: {
            middleware: [
                auth,
            ],
            title: "Dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/index.vue"),
    },
    {
        path: "/dashboard/convention",
        name: "dashboard.convention",
        meta: {
            middleware: [
                auth,
            ],
            title: "Dashboard Convention",
            authRequired: true,
            permission: "view-dashboard-convention",
        },
        component: () => import("../views/dashboard/convention/index.vue"),
    },
    {
        path: "/dashboard/expert",
        name: "dashboard.expert",
        meta: {
            middleware: [
                auth,
            ],
            title: "Dashboard Expert",
            authRequired: true,
            permission: "view-dashboard-expert",
        },
        component: () => import("../views/dashboard/expert/index.vue"),
    },
    {
        path: "/dashboard/protocole",
        name: "dashboard.protocole",
        meta: {
            middleware: [
                auth,
            ],
            title: "Dashboard Protocole",
            authRequired: true,
            permission: "view-dashboard-protocole",
        },
        component: () => import("../views/dashboard/protocole/index.vue"),
    },
    {
        path: "/dashboard/plan-affaire",
        name: "dashboard.plan-affaire",
        meta: {
            middleware: [
                auth,
            ],
            title: "Dashboard Plan d'affaire",
            authRequired: true,
            permission: "view-dashboard-plan-affaire",
        },
        component: () => import("../views/dashboard/plan-affaire/index.vue"),
    },
    {
        path: "/notifications",
        name: "notifications.index",
        meta: {
            middleware: [
                auth,
            ],
            title: "Notifications",
            authRequired: true,
        },
        component: () => import("../views/notifications/index.vue"),
    },
    {
        path: "/logout",
        name: "logout",
        meta: {
            title: "Logout", authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                localStorage.clear();
                sessionStorage.clear();
                next();
            },
        },
        component: () => import("../views/auth/logout/basic")
    },
    {
        path: "/profile",
        name: "profile",
        meta: {
            title: "Profile", authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                localStorage.clear();
                sessionStorage.clear();
                next();
            },
        },
        component: () => import("../views/profile/setting.vue")
    },
    {
        path: '/auth/404',
        name: '404',
        meta: {
            title: "Error 404", authRequired: true,
        },
        component: () => import('../views/auth/errors/404')
    },
    {
        path: '/auth/500',
        name: '500',
        meta: {
            title: "Error 500", authRequired: true,
        },
        component: () => import('../views/auth/errors/500')
    },
    {
        path: '/*/',
        name: '404-basic',
        meta: {
            title: "Error 404", authRequired: true,
        },
        component: () => import('../views/auth/errors/404-basic')
    },
    {
        path: '/auth/404-cover',
        name: '404-cover',
        meta: {
            title: "Error 404", authRequired: true,
        },
        component: () => import('../views/auth/errors/404-cover')
    },
    {
        path: '/auth/logout-basic',
        name: 'logout-basic',
        meta: {
            middleware: [
                auth,
            ],
            title: "Logout", authRequired: true,
        },
        component: () => import('../views/auth/logout/basic')
    },
    {
        path: '/auth/logout-cover',
        name: 'logout-cover',
        meta: {
            middleware: [
                auth,
            ],
            title: "Logout", authRequired: true,
        },
        component: () => import('../views/auth/logout/cover')
    },
    {
        path: '/auth/success-msg-basic',
        name: 'success-msg-basic',
        meta: {
            middleware: [
                auth,
            ],
            title: "Success Message", authRequired: true,
        },
        component: () => import('../views/auth/success-msg/basic')
    },
    {
        path: '/auth/success-msg-cover',
        name: 'success-msg-cover',
        meta: {
            middleware: [
                auth,
            ],
            title: "Success Message", authRequired: true,
        },
        component: () => import('../views/auth/success-msg/cover')
    },
    //staff
    {
        path: '/staff',
        name: 'staff.index',
        meta: {
            middleware: [
                auth,
            ],
            title: "Utilisateur", authRequired: true,
        },
        component: () => import('../views/configs/common/staff/index.vue')
    },
    {
        path: '/configs',
        name: 'configs.index',
        meta: {
            middleware: [
                auth,
            ],
            title: "Configurations", authRequired: true,
        },
        component: () => import('../views/configs/index.vue')
    },
    {
        path: '/onboarding',
        name: 'onboard',
        meta: {
            /* middleware: [
               //auth,
             ],*/
            title: "On boarding", authRequired: true,
        },
        component: () => import('../views/account/projects.vue')
    },
    {
        path: "/portal/public",
        name: "public-portal",
        component: () => import("../views/public/portal.vue"),
        meta: {
            title: "Portail Public PADMAR-E",
            authRequired: false,
            cible: "padmar",
        },
    },
    {
        path: "/portal/folders/:slug",
        name: "public-folder",
        component: () => import("../views/public/PublicFolder.vue"),
        meta: {
            title: "Dossier Public",
            authRequired: false,
            cible: "padmar",
        },
    },
    {
        // path: "*",
        path: "/:catchAll(.*)",
        name: "NotFound",
        meta: {
            title: "Page introuvable",
        },
        component: () => import('../views/auth/errors/404-basic.vue')
    }

];

export default [...routes, ...configRoutes, ...vegolaRoutes];